import { OperationalOptimizationsActionTypes } from './constants';

export const INIT_STATE = {
    errorGetOptimizedGroundVsAir: null,
    loadingOptimizedGroundVsAir: false,
    optimizedGroundVsAir: null,
    errorGetGroundVsAir: null,
    loadingGroundVsAir: false,
    groundVsAir: null,
    errorGetGroundVsAirDetails: null,
    loadingGroundVsAirDetails: false,
    groundVsAirDetails: null,
    errorGetOptimizedGroundVsAirDetails: null,
    loadingOptimizedGroundVsAirDetails: false,
    optimizedGroundVsAirDetails: null,
};

type OperationalOptimizationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    errorGetGroundVsAir: null,
    loadingGroundVsAir: false,
    groundVsAir: any,
    errorGetOptimizedGroundVsAir: null,
    loadingOptimizedGroundVsAir: false,
    optimizedGroundVsAir: any,
    errorGetGroundVsAirDetails: null,
    loadingGroundVsAirDetails: false,
    groundVsAirDetails: any,
    errorGetOptimizedGroundVsAirDetails: null,
    loadingOptimizedGroundVsAirDetails: false,
    optimizedGroundVsAirDetails: any,
};

const OperationalOptimizations = (state: State = INIT_STATE, action: OperationalOptimizationsAction): any => {
    switch (action.type) {
        case OperationalOptimizationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR: {
                    return { ...state, loadingGroundVsAir: false, groundVsAir: action.payload.data };
                }
                case OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR: {
                    return { ...state, loadingOptimizedGroundVsAir: false, optimizedGroundVsAir: action.payload.data };
                }
                case OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR_DETAILS: {
                    return { ...state, loadingGroundVsAirDetails: false, groundVsAirDetails: action.payload.data };
                }
                case OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR_DETAILS: {
                    return { ...state, loadingOptimizedGroundVsAirDetails: false, optimizedGroundVsAirDetails: action.payload.data };
                }
                default:
                    return { 
                        ...state, 
                        loadingOptimizedGroundVsAir: false, 
                        loadingGroundVsAir: false, 
                        loadingGroundVsAirDetails: false,
                        loadingOptimizedGroundVsAirDetails: false,
                    };
            }

        case OperationalOptimizationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR: {
                    return { ...state, loadingGroundVsAir: false, errorGetGroundVsAir: action.payload.error };
                }
                case OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR: {
                    return { ...state, loadingOptimizedGroundVsAir: false, errorGetOptimizedGroundVsAir: action.payload.error };
                }
                case OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR_DETAILS: {
                    return { ...state, loadingGroundVsAirDetails: false, errorGetGroundVsAirDetails: action.payload.error };
                }
                case OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR_DETAILS: {
                    return { ...state, loadingOptimizedGroundVsAirDetails: false, errorGetOptimizedGroundVsAirDetails: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR:
            return { ...state, loadingGroundVsAir: true, groundVsAir: null };
        case OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR:
            return { ...state, loadingOptimizedGroundVsAir: true, optimizedGroundVsAir: null };
        case OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR_DETAILS:
            return { ...state, loadingGroundVsAirDetails: true, groundVsAirDetails: null };
        case OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR_DETAILS:
            return { ...state, loadingOptimizedGroundVsAirDetails: true, optimizedGroundVsAirDetails: null };
        default:
            return { ...state };
    }
};

export default OperationalOptimizations;
